import { SpotList } from "Domain/Model/SpotList/SpotList";

export const UPDATE_SPOT_LIST_SUCCESS = 'UPDATE_SPOT_LIST_SUCCESS';

export const updateSpotListSuccess = (payload: Record<string, SpotList>) => ({
    type: UPDATE_SPOT_LIST_SUCCESS,
    payload,
});
